import { combineReducers } from "redux";
import apiCallsInProgress from "./apiStatusReducer";
import profileReducer from "./profileReducer";
import jobReducer from "./jobReducer";
import claimedJobReducer from "./claimedJobReducer";
import myJobsReducer from "./myJobsReducer";
import myCompletedJobsReducer from "./myCompletedJobsReducer";
import myInstalledJobsReducer from "./myInstalledJobsReducer";
import myAwaitingPaymentJobsReducer from "./myAwaitingPaymentJobsReducer";
import myProgressedJobsReducer from "./myProgressedJobsReducer";
import completeJobReducer from "./completeJobReducer";

const rootReducer = combineReducers({
  apiCallsInProgress: apiCallsInProgress,
  profile: profileReducer,
  jobs: jobReducer,
  claimedJob: claimedJobReducer,
  myJobs: myJobsReducer,
  myCompletedJobs: myCompletedJobsReducer,
  myInstalledJobs: myInstalledJobsReducer,
  myAwaitingPaymentJobs: myAwaitingPaymentJobsReducer,
  myProgressedJobs: myProgressedJobsReducer,
  completingJob: completeJobReducer,
});

export default rootReducer;
